import { Templater } from '../Template/Templater';
import { FontFamilyHelper } from '../Util/FontFamilyHelper';
import { PascalCaseConverter } from '../Util/PascalCaseConverter';
/* tslint:enable:no-any */
var WidgetContent = /** @class */ (function () {
    function WidgetContent() {
        this._cacheIcons = {};
    }
    WidgetContent.prototype.getBaseUrl = function () {
        // Fix Firefox bug with unsupported base tag in iframe
        var hostUrl = TL && TL.integration && TL.integration.baseHost;
        return hostUrl ? 'https://' + hostUrl : '';
    };
    WidgetContent.prototype.processTemplate = function (html) {
        var container = document.createElement('template');
        if ('content' in document.createElement('template')) {
            container.innerHTML = html;
            return container.content.firstElementChild;
        }
        else {
            container.insertAdjacentHTML('beforeend', html);
            return container.firstElementChild;
        }
    };
    WidgetContent.prototype.processStyles = function (styles) {
        var style = document.createElement('style');
        style.appendChild(document.createTextNode(styles));
        return style;
    };
    WidgetContent.prototype.processIcon = function (iconContainer, iconKind) {
        var _this = this;
        if (!iconKind) {
            return;
        }
        if (this._cacheIcons[iconKind]) {
            iconContainer.innerHTML = this._cacheIcons[iconKind];
            return;
        }
        var ajax = new XMLHttpRequest(), path = this.getBaseUrl() ? this.getBaseUrl() + '/smartwidget/' : '';
        ajax.open('GET', path + "icons/" + iconKind.toLocaleLowerCase() + ".svg", true);
        ajax.send();
        /* tslint:disable:no-any */
        ajax.onload = function (e) {
            if (e.target.status === 200) {
                iconContainer.innerHTML = _this._cacheIcons[iconKind] = ajax.responseText;
            }
        };
        /* tslint:enable:no-any */
    };
    WidgetContent.prototype.updateStyles = function (styles, defaultStyles) {
        if (!styles || Object.keys(styles).length === 0) {
            return defaultStyles;
        }
        var customStyles = defaultStyles;
        for (var key in styles) {
            if (styles.hasOwnProperty(key)) {
                var name_1 = PascalCaseConverter.toKebabCase(key);
                var value = styles[key];
                var regexp = new RegExp("--" + name_1 + ":([^;}]+)(;|[^}])");
                if (name_1.indexOf('font-size') > -1) {
                    value += 'px';
                }
                if (name_1.indexOf('font-family') > -1) {
                    value = FontFamilyHelper.getFont(parseInt(value, 10)).style;
                }
                customStyles = customStyles.replace(regexp, "--" + name_1 + ": " + Templater.sanitizeCssVar(value.toString()) + ";");
            }
        }
        return customStyles;
    };
    WidgetContent.prototype.processFonts = function (styles) {
        var htmlLinks = [];
        if (!styles || Object.keys(styles).length === 0) {
            return htmlLinks;
        }
        for (var key in styles) {
            if (styles.hasOwnProperty(key)) {
                var name_2 = PascalCaseConverter.toKebabCase(key);
                var value = styles[key];
                if (name_2.indexOf('font-family') > -1) {
                    var font = FontFamilyHelper.getFont(parseInt(value, 10));
                    var htmlFontLink = Templater.createFontLink(font, this.getBaseUrl());
                    if (htmlFontLink) {
                        htmlLinks.push(htmlFontLink);
                    }
                }
            }
        }
        return htmlLinks;
    };
    return WidgetContent;
}());
export { WidgetContent };
